/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import {
    IMultiAxisDatasetNode
} from '../types/MultiAxisDatasetTypes';

function getMultiAxisDatasetNodeInternal(root: IMultiAxisDatasetNode, path: string[], depth: number, stack: IMultiAxisDatasetNode[]) {
    let res = stack;
    if (depth < path.length) {
        let child = root.children.find((c) => (c.label === path[depth]));
        if (!child && path[depth] === 'All') {
            child = root.total as IMultiAxisDatasetNode;
        }

        if (child) {
            res.push(child);
            res = getMultiAxisDatasetNodeInternal(child, path, depth + 1, stack);
        }
    }

    return res;
}

export default function getMultiAxisDatasetNode(root: IMultiAxisDatasetNode, path: string[]): IMultiAxisDatasetNode[] {
    let res = getMultiAxisDatasetNodeInternal(root, path, 0, [root]);

    if (res.length !== path.length + 1) {
        res = [];
    }

    return res;
}
